export class TrainingStatusConstants{
    public static readonly TrainingStatusReport_Header: string = 'Training Status Report';
    public static readonly TrainingStatusReport_eQMSScope_Required: string = 'eQMS Scope(s) is required';
    public static readonly TrainingStatusReport_AssignmentDateRange_Required: string = 'Assignment Date Range is required';
    public static readonly TrainingStatusReport_RangeSelection_Error: string = 'Assignment Date Range should be less than or equal to 1 year';
    public static readonly InvalidAssignmentDateRangeSelection: string = 'Invalid Assignment Range Date Selection';
    public static readonly SpinnerMessageFor_TrainingStatusReport: string = 'Generating Training Status Report';
    public static readonly TrainingStatusReport_RoleAcessPermission_Fail: string = "Unable to fetch Roles permission";
    public static readonly Severity_Success: string = 'success';
    public static readonly Severity_Error: string = 'error';
    public static readonly ErrorMessage_ForNoTrainingOccurence = 'You don\'t have any Training Occurence';

    public static readonly labelField_Name: string = 'name';
    public static readonly labelField_Value: string = 'value'; 
    
    public static readonly FilterLength: number = 8;
}